<script>
import OrderForm from '../collection/_Form.vue'
export default {
  name: 'DriverOrderAcceptSelfEmissionDuplicate',
  components: {
    OrderForm
  },
  mixins: [],
  props: {},
  data() {
    return {
      breadcrumbs: [
        { text: '受注一覧', disabled: false, to: '/driver/orders/accepts', exact: true },
        { text: '新規登録', disabled: true, to: '' },
      ],
      duplicateOrderId: null,
    }
  },
  computed: {},
  watch: {},
  created() {
    this.duplicateOrderId = parseInt(this.$route.params.duplicate_id)
  },
  methods: {}
}
</script>
<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <h2>
      新規登録（排出持込）
    </h2>
    <order-form :duplicate-order-id="duplicateOrderId" callable-type="self_emission" />
  </v-container>
</template>
